/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import ChartTemplate from "../viewer_chart/ChartTemplate";

/*REDUX*/
import { set_value_insight } from "../../App/actions/insight_v2";
import { show_top_result_saved } from "../../App/actions/site_selections";
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

const SS_PIE_CHART = ({ auth, layer, insight_reducer }) => {
  //local storage
  // const language = localStorage?.language || auth.language;

  //global props
  const { geo_layer_list, layer_id } = layer;
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;
  const features = geo_layer?.geojson?.features || [];
  const style_array = geo_layer?.style_array || [];

  let color_array = [];
  let text_array = [];
  let number_array = [0, 0, 0, 0, 0];

  if (style_array.length > 0) {
    const default_style_key = geo_layer?.default_style_key || "";
    const style_object = style_array.find(
      (item) => item.key === default_style_key
    );
    const style_type = style_object?.style_type;
    const paint_object = style_object?.paint_object || {};
    let color_key;
    if (style_type === "circle") {
      color_key = "circle-color";
    } else if (style_type === "line") {
      color_key = "line-color";
    } else if (style_type === "fill") {
      color_key = "fill-color";
    }
    let color_object = paint_object?.[color_key] || [];

    // Loop through color_object, starting from the 3rd element and stopping before the last
    for (let i = 2; i < color_object.length - 1; i += 2) {
      text_array.push(color_object[i]);
      color_array.push(color_object[i + 1]);
    }

    features.forEach((feature) => {
      const value =
        feature?.properties?.HASIL || feature?.properties?.FINAL_STATUS_SCORE;
      const index = text_array.findIndex((item) => item === value);
      number_array[index] = number_array[index] + 1;
    });
  }

  const chart_js_data = {
    labels: text_array,
    datasets: [
      {
        label: "Site Selection",
        labels: text_array,
        data: number_array,
        backgroundColor: color_array,
        borderColor: "black",
        borderWidth: 1,
      },
    ],
  };

  return (
    <main>
      <ChartTemplate
        type="pie"
        width={100}
        height={100}
        style={{ width: "100px", margin: "auto" }}
        options={{
          animation: false,
          maintainAspectRatio: true,
          responsive: false,
          legend: {
            display: false,
          },
          indexAxis: "x",
          title: {
            display: false,
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        }}
        data={chart_js_data}
      />
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  show_top_result_saved,
  set_value_insight,
  set_value_layer,
})(SS_PIE_CHART);
